import { SceneWithTagsAndProducts, TagWithNonNullProduct } from "../types";

const Scene = {
  getTags(scene: SceneWithTagsAndProducts) {
    return scene.tags.filter(tag => !!tag.geometry && !!tag.product) as TagWithNonNullProduct[];
  }
};

export default Scene;
